import React, { useEffect, useState } from 'react';
import { Form, Radio, Space, Input } from 'antd';
import type { RadioChangeEvent } from 'antd';
import '../SurveyAnswer.less';
import { useParams } from 'react-router-dom';

const Single = ({ body, required, id, optionList, num, initForm, form }: { body?: string; required?: boolean; optionList?: Array<string>; num?: number; id?: number; initForm?: any; form?: any }) => {
    const params: any = useParams();
    const [value, setValue] = useState();
    const [optionArr, setOptionArr] = useState([]);
    const [isShowTip, setIsShowTip] = useState(false);

    const onChange = (e: RadioChangeEvent) => {
        setValue(e.target.value);

        // 问卷969 - 题目选项跳转
        if (params?.id === '969') {
            let targetVal = '';
            let arr: any = optionArr.filter((item: any) => item.id === e.target.value);
            if (arr && arr.length) {
                targetVal = arr[0].content;
            }
            if (targetVal.includes('###')) {
                const url = targetVal.split('###') && targetVal.split('###').length > 1 ? targetVal.split('###')[1] : '';
                if (url) {
                    window.location.href = url;
                }
            }
        }
    };

    const getOptionContent = (content: any) => {
        if (params?.id === '969' && content && content.includes('###')) {
            return content.split('###')[0];
        } else {
            return content;
        }
    };

    useEffect(() => {
        if (optionList && optionList.length) {
            let arr: any = optionList.filter((item: any) => !item.isBlank);
            let arrBlank = optionList.filter((item: any) => item.isBlank);
            setOptionArr(arr.concat(arrBlank));
            if (initForm) {
                const val = initForm[`${id}-1`];
                if (val && val.length) {
                    setValue(val[0]);
                    form.setFieldValue([`${id}-1`, 0], val[0]);
                }
            } else {
                let answer;
                let selectArr: any[] = optionList.filter((it: any) => it.selected);
                answer = selectArr && selectArr.length ? selectArr[0].id : '';
                setValue(answer);
            }
        }
    }, [optionList, initForm]);

    useEffect(() => {
        if (optionList && optionList.length) {
            let arrBlank: any = optionList.filter((item: any) => item.isBlank);
            if (arrBlank && arrBlank.length) {
                if (value && value !== arrBlank[0].id) {
                    form.setFieldValue([`${id}-1`, 1], '');
                    setIsShowTip(false);
                }
            }
        }
    }, [value, optionList]);

    return (
        <>
            <Form.Item
                name={[`${id}-1`, 0]}
                rules={[
                    {
                        required,
                        message: '该题为必答题，请作答后提交。',
                    },
                ]}
                label={<div className="label-flex" style={{ display: 'flex' }} dangerouslySetInnerHTML={{ __html: `<span class="title-num">${num}.</span>` + `<span>${body}</span>` }}></div>}
            >
                <Radio.Group style={{ width: '100%' }} onChange={onChange} value={value}>
                    <Space direction="vertical" style={{ width: '100%' }}>
                        {optionArr && optionArr.length
                            ? optionArr.map((option: any) => (
                                  <div key={option.id}>
                                      {option.isBlank === 0 ? (
                                          <Radio value={option.id} disabled={params?.id === '190' && option.id === 1869 ? true : false}>
                                              {getOptionContent(option.content)}
                                          </Radio>
                                      ) : (
                                          <Radio value={option.id} style={{ width: '100%' }}>
                                              <div className="single-topic" style={{ width: '100%' }}>
                                                  <p>{getOptionContent(option.content)}</p>
                                                  <Form.Item
                                                      name={[`${id}-1`, 1]}
                                                      label=""
                                                      rules={[
                                                          {
                                                              required: value === option.id,
                                                              validator: async (rule, val) => {
                                                                  if (!val && value === option.id) {
                                                                      setIsShowTip(true);
                                                                      throw '';
                                                                  } else {
                                                                      setIsShowTip(false);
                                                                  }
                                                              },
                                                          },
                                                      ]}
                                                  >
                                                      <Input style={{ marginLeft: 10, borderColor: isShowTip ? 'red' : 'black' }} autoComplete="off" maxLength={200} readOnly={value !== option.id} />
                                                  </Form.Item>
                                              </div>
                                          </Radio>
                                      )}
                                  </div>
                              ))
                            : null}
                    </Space>
                </Radio.Group>
            </Form.Item>
        </>
    );
};

export default Single;
